import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { baseTableFilter, buildQueryString } from 'utils/general';

export const initialState = {
    loading: false,
    message: '',
    showMessage: false,
};

export const getAllUserCount = createAsyncThunk('dashboard/getAllUserCount', async (filter, { rejectWithValue }) => {

    try {
        const response = await axiosInstance.get(
            `dashboard/counts/${filter?.type ? filter.type : "user"}?startDate=${filter?.startDate}&endDate=${filter?.endDate}&filterType=${filter?.dateType ? filter.dateType : 'date'}&categoryId=${filter?.categoryId ? filter.categoryId : ''}&subCategoryId=${filter?.subCategoryId ? filter.subCategoryId : ''}`,
        );

        if (response.success) {
            return response;
        } else {
            return rejectWithValue(response.message?.replace('Firebase: ', ''));
        }
    } catch (err) {
        return rejectWithValue(err.message || 'Error');
    }
});

export const getAllUserAnalytics = createAsyncThunk('dashboard/getAllUserAnalytics', async (filter, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(
            `dashboard/analytics/${filter?.type ? filter.type : "user"}?startDate=${filter?.startDate}&endDate=${filter?.endDate}&filterType=${filter?.dateType ? filter.dateType : 'day'}&categoryId=${filter?.categoryId ? filter.categoryId : ''}&subCategoryId=${filter?.subCategoryId ? filter.subCategoryId : ''}`,
        );

        if (response.success) {
            return response;
        } else {
            return rejectWithValue(response.message?.replace('Firebase: ', ''));
        }
    } catch (err) {
        return rejectWithValue(err.message || 'Error');
    }
});


export const getListingStatics = createAsyncThunk('dashboard/getListingStatics', async (filter, { rejectWithValue }) => {
console.log('filter :>> ', filter);
    const query = new URLSearchParams(filter).toString();
    try {
        const response = await axiosInstance.get(
            `dashboard/listing-statistics?${query}`,
        );

        if (response.success) {
            return response;
        } else {
            return rejectWithValue(response.message?.replace('Firebase: ', ''));
        }
    } catch (err) {
        return rejectWithValue(err.message || 'Error');
    }
});


export const getMapListingData = createAsyncThunk('dashboard/getListingStatics', async (filter, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(
            `dashboard/listed-from/${filter?.dataType ? filter.dataType : 'product'}?startDate=${filter?.startDate}&endDate=${filter?.endDate}&filterType=${filter?.dateType ? filter.dateType : 'date'}&categoryId=${filter?.categoryId ? filter.categoryId : ''}&subCategoryId=${filter?.subCategoryId ? filter.subCategoryId : ''}`,
        );

        if (response.success) {
            return response;
        } else {
            return rejectWithValue(response.message?.replace('Firebase: ', ''));
        }
    } catch (err) {
        return rejectWithValue(err.message || 'Error');
    }
});


// export const getBarStatics = createAsyncThunk('dashboard/getBarStatics', async (filter, { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.get(
//             `dashboard/listing-bar?startDate=${filter?.startDate}&endDate=${filter?.endDate}&filterType=${filter?.dateType ? filter.dateType : 'day'}`,
//         );

//         if (response.success) {
//             return response;
//         } else {
//             return rejectWithValue(response.message?.replace('Firebase: ', ''));
//         }
//     } catch (err) {
//         return rejectWithValue(err.message || 'Error');
//     }
// });
export const getAllMainCategories = createAsyncThunk('category/getAllMainCategories', async (options, { rejectWithValue }) => {
    
    // category, service-category, product-category
    const { type, ...data } = options;
    try {
        const query = new URLSearchParams(data).toString();

        console.log(query, 'query...');

        const response = await axiosInstance.get(`/${type ? type : 'category'}/admin?${query}`);
        if (response.success) {
            return response;
        }

        rejectWithValue({ data: [], success: false });
    } catch (error) {
        console.error(error);
        return rejectWithValue(error.response || {});
    }
});

export const getAllSubCategories = createAsyncThunk('subCategory/getAllSubCategories', async (options = {}, { rejectWithValue }) => {
    // sub-category, service-subcategory, product-subcategory
    const { type, ...data } = options;
    try {
        const query = new URLSearchParams(data).toString();

        const response = await axiosInstance.get(`/${type ? type : 'sub-category'}/admin?${query}`);
        if (response.success) {
            return response;
        }

        rejectWithValue({ data: [], success: false });
    } catch (error) {
        console.error(error);
        return rejectWithValue(error.response || {});
    }
});

export const userDashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllUserCount.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllUserCount.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(getAllUserCount.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(getAllUserAnalytics.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllUserAnalytics.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(getAllUserAnalytics.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(getListingStatics.pending, (state) => {
                state.loading = true;
            })
            .addCase(getListingStatics.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(getListingStatics.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            })
            .addCase(getMapListingData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getMapListingData.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(getMapListingData.rejected, (state, action) => {
                state.message = action.payload;
                state.showMessage = true;
                state.loading = false;
            });
    },
});

export const { showLoading } = userDashboardSlice.actions;

export default userDashboardSlice.reducer;
